import ReservationsList from './reservations-list'

export default ReservationsList
